import React from "react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/33663252202?text=Bonjour%20Maxime%2C%20je%20vous%20contacte%20via%20votre%20site%20MaximeH.fr"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        width: "56px",
        height: "56px",
        backgroundColor: "#0f0f0f",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
        zIndex: 1000,
        transition: "all 0.3s ease"
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 32 32"
        fill="white"
      >
        <path d="M16.04 3C8.83 3 3 8.82 3 16c0 2.82.74 5.5 2.14 7.85L3 29l5.29-2.09A12.9 12.9 0 0 0 16.04 29C23.24 29 29 23.18 29 16S23.24 3 16.04 3zm0 23.33c-2.39 0-4.72-.64-6.77-1.86l-.48-.29-3.14 1.24 1.27-3.05-.31-.5A10.3 10.3 0 0 1 5.7 16c0-5.69 4.64-10.33 10.34-10.33 5.69 0 10.33 4.64 10.33 10.33s-4.64 10.33-10.33 10.33zm5.67-7.74c-.31-.16-1.85-.91-2.14-1.02-.29-.1-.5-.16-.71.16-.21.31-.81 1.02-.99 1.23-.18.21-.36.24-.67.08-.31-.16-1.3-.48-2.47-1.52-.91-.81-1.52-1.81-1.7-2.12-.18-.31-.02-.48.14-.63.14-.14.31-.36.47-.54.16-.18.21-.31.31-.52.1-.21.05-.39-.02-.54-.08-.16-.71-1.71-.97-2.34-.26-.63-.53-.54-.71-.55-.18-.01-.39-.01-.6-.01-.21 0-.54.08-.83.39-.29.31-1.09 1.07-1.09 2.61 0 1.54 1.12 3.03 1.28 3.24.16.21 2.2 3.35 5.33 4.69.75.32 1.33.51 1.79.65.75.24 1.43.21 1.97.13.6-.09 1.85-.75 2.11-1.48.26-.73.26-1.36.18-1.48-.08-.13-.29-.21-.6-.37z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;